var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18.32 18.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "18.32 3.78 14.54 0 9.16 5.38 3.78 0 0 3.78 5.38 9.16 0 14.54 3.78 18.32 9.16 12.94 14.54 18.32 18.32 14.54 12.94 9.16 18.32 3.78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4187afb59dbaa350513c2a5aeb688e34.svg";
export { ForwardRef as ReactComponent };